module.exports = __webpack_public_path__ + "static/media/clipart-camera-security-camera-7-transparent.53a658e5.png";